import * as angular from "angular";
import {IController, IScope} from "angular";
import * as _ from "lodash";

export class RouteListItemCtrl implements IController {

  id: string;
  onClick: Function;
  onCreate: Function;

  public isSuggestion;
  public route: any;


  constructor(private $scope: IScope, private $route, private $log) {

  }

  $onInit() {
    this.$route(this.id).$bindCtrl(this.$scope, this, 'route')
      .then((route) => {
          this.isSuggestion = _.isEqual(route.status, 'Suggestion')
        },
        (error) => {
          this.$log.error('Failed to bind route to scope ' +
            'routeListItem \n' + error)
        }
      );
  }

}


angular
  .module('bringoz.admin.routes')
  .component('routeListItem', {
    bindings: {
      id: '<?',
      onClick: '&',
      onCreate: '&'
    },
    template: require('./route-list-item.html').default,
    controller: RouteListItemCtrl
  });
